/**
 * Advanced facet keys that should stay hidden from the user-facing filters UI.
 *
 * These facets are either surfaced elsewhere (brand, color, price), implicit
 * navigational context (gender), or internal/system facets that should not
 * inflate the sidebar's applied-filter count.
 */
export const HIDDEN_ADVANCED_ATTRIBUTE_KEYS = new Set([
  "age_group",
  "age_groups",
  "brand_name",
  "color",
  "color_family",
  "gender",
  "is_activewear",
  "price",
  "price_range",
  "product_type",
  "raw_brand_name",
  "size",
  "size_type",
  "target_gender",
]);

export function isHiddenAdvancedAttributeKey(attributeKey: string): boolean {
  return HIDDEN_ADVANCED_ATTRIBUTE_KEYS.has(attributeKey);
}
